export abstract class ComponentConfigBase<T> {
  constructor(data?: Partial<T>) {
    if (data) {
      Object.assign(this, data);
    }
    this.setFallbackDefaults();
  }

  /**
   * Called at the end of the super constructor.
   * Intended for setting default values in case no values were provided.
   */
  abstract setFallbackDefaults(): void;
}
